import React from "react";
import {
    Chart,
    Geom,
    Axis,
    Tooltip,
    Legend,
} from "bizcharts";
import DataSet from "@antv/data-set";

function Line({data, fields, axisY}){
    const ds = new DataSet();
    const dv = ds.createView().source(data);
    dv.transform({
        type: "fold",
        fields: fields,
        key: "city",
        value: "verticalInfo"
    });

    const cols = {
        label: {
          range: [0, 1]
        }
    };
    
    if(data.length > 0){
        return (
            <div>
                <Chart 
                    height={450} 
                    data={dv} 
                    scale={cols} 
                    padding={[40, 60, 80, 50]}
                    forceFit
                >
                    <Legend/>
                    <Axis name="label" />
                    <Axis
                        name="verticalInfo"
                        label={{
                            formatter: val => `${val} ${axisY ? axisY : ""}`
                        }}
                    />
                    <Tooltip
                        crosshairs={{
                            type: "y"
                        }}
                    />
                    <Geom
                        type="line"
                        position="label*verticalInfo"
                        size={2}
                        color={"city"}
                        shape={"smooth"}
                    />
                    <Geom
                        type="point"
                        position="label*verticalInfo"
                        size={4}
                        shape={"circle"}
                        color={"city"}
                        style={{
                            stroke: "#fff",
                            lineWidth: 1
                        }}
                    />
                </Chart>
            </div>
        );
    }else return null;
}

export default Line;


// WEBPACK FOOTER //
// ./src/components/common/charts/Line.jsx